import {create} from 'zustand';

const useCotizadorStore = create((set, get) => ({
    cotizador: JSON.parse(localStorage.getItem('cotizador')) || [],
    addToCotizador: (data) => {
        const tempCotizador = get().cotizador
        const cotizadorIndex = tempCotizador.findIndex(el => el.id === data.id)
        if(cotizadorIndex != -1){
            tempCotizador[cotizadorIndex].qty += 1
            set(() => ({
                cotizador: [...tempCotizador]
            }))
        } else{
            data.qty = 1
            set((state) => ({
                cotizador: [...state.cotizador, data]
            }))
        }
        localStorage.setItem('cotizador', JSON.stringify(get().cotizador))
    },
    deleteFromCotizador: (data) => {
        const tempCotizador = get().cotizador
        const cotizadorIndex = tempCotizador.findIndex(el => el.id === data.id)
        if(tempCotizador[cotizadorIndex].qty > 1){
            tempCotizador[cotizadorIndex].qty -= 1
            set(() => ({
                cotizador: [...tempCotizador]
            }))
        } else{
            set((state) => ({
                cotizador: [...state.cotizador.filter(el => el.id !== data.id)]
            }))
        }
        localStorage.setItem('cotizador', JSON.stringify(get().cotizador))
    }
}))

export default useCotizadorStore;